import { Component , OnInit } from '@angular/core';
import { TokenStorageService } from './_services/auth/token-storage.service';
import { FacebookLoginProvider, SocialUser } from 'angularx-social-login';
import { Router, NavigationEnd } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit {
  title = 'argon-dashboard-angular';
  isLoggedIn = false;
  username: string;
  user: SocialUser;
  loggedIn: boolean; 
  loading = true ; 
  constructor(private tokenStorageService: TokenStorageService){}
  ngOnInit() {
   
    this.isLoggedIn = !!this.tokenStorageService.getToken();

    if (this.isLoggedIn) {
      const user = this.tokenStorageService.getUser();

      this.username = user.username;
    }
  }

}
